import { Box, Card, CardContent } from '@mui/material';
import React from 'react';
import { PermissionState } from '../../types';
import { StatusSwitch } from './StatusSwitch';

interface Props<T extends PermissionState> {
  readonly permissionState: T;
  readonly onToggleEnabled: (enabled: boolean) => void;
  readonly canModify: boolean;
  readonly disabled?: boolean;
  readonly children: React.ReactNode;
}

export function BasePermission<T extends PermissionState>(p: Props<T>) {
  return (
    <Card data-cy="permission-widget">
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box>
            {!p.canModify ? (
              <StatusSwitch disabled checked />
            ) : (
              <StatusSwitch
                checked={p.permissionState.permission !== null}
                onChange={(event) => {
                  p.onToggleEnabled(event.target.checked);
                }}
                disabled={p.disabled}
              />
            )}
          </Box>
          <Box sx={{ flexGrow: 1 }}>{p.children}</Box>
        </Box>
      </CardContent>
    </Card>
  );
}
